module.exports = MaterialUI.ExpansionPanelSummary;